"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(activity) {
  return activity && activity.from.role === 'bot';
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kZWZpbml0aW9ucy9hY3Rpdml0eUZyb21Cb3QuanMiXSwibmFtZXMiOlsiYWN0aXZpdHkiLCJmcm9tIiwicm9sZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztlQUFlLGtCQUFBQSxRQUFRO0FBQUEsU0FBSUEsUUFBUSxJQUFJQSxRQUFRLENBQUNDLElBQVQsQ0FBY0MsSUFBZCxLQUF1QixLQUF2QztBQUFBLEMiLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBhY3Rpdml0eSA9PiBhY3Rpdml0eSAmJiBhY3Rpdml0eS5mcm9tLnJvbGUgPT09ICdib3QnO1xuIl19